// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__367b8","content":"styles_content__llEug","tableWrap":"styles_tableWrap__1yJyv"};